import { render } from "./Error.vue?vue&type=template&id=671a543e"
import script from "./Error.vue?vue&type=script&setup=true&lang=js"
export * from "./Error.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "671a543e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('671a543e', __exports__)) {
    api.reload('671a543e', __exports__)
  }
  
  module.hot.accept("./Error.vue?vue&type=template&id=671a543e", () => {
    api.rerender('671a543e', render)
  })

}


export default __exports__